"use strict";var T;exports.CTAType=void 0,(T=exports.CTAType||(exports.CTAType={})).DEEPLINK="DEEPLINK",T.STATIC="CLOSE_BOTTOMSHEET_CTA",T.PLAN_PURCHASE="PLAN_PURCHASE_CTA",T.CTA_TEXT_BUTTON="CTA_TEXT_BUTTON";
//# sourceMappingURL=type.js.map
